import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import OnboardingWizard from '../../components/Onboarding/OnboardingWizard';
import { GetData } from '../../services/api';
import Loader from '../../components/Common/Loader';

const OnboardingPage = () => {
  const navigate = useNavigate();
  const [onboardingData, setOnboardingData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkOnboarding = async () => {
      try {
        const response = await GetData('/users/onboarding-status').catch(err => {
          console.warn("Error checking onboarding status:", err);
          return { data: { completed: true } };
        });
        
        if (response?.data) {
          if (response.data.completed) {
            // Si ya completó el onboarding, redirigir al dashboard
            navigate('/dashboard');
          } else {
            setOnboardingData(response.data);
          }
        }
      } catch (error) {
        console.error('Error checking onboarding status:', error);
        // En caso de error, redirigir al dashboard
        navigate('/dashboard');
      } finally {
        setLoading(false);
      }
    };
    
    checkOnboarding();
  }, [navigate]);

  if (loading) {
    return <Loader message="Cargando ..." fullScreen={true} size={200} />;
  }

  if (!onboardingData) {
    return null; // Se está redirigiendo
  }

  return (
    <OnboardingWizard 
      userPlan={onboardingData.plan}
      onComplete={() => {
        // Redirigir al dashboard después de completar
        navigate('/dashboard');
      }}
    />
  );
};

export default OnboardingPage;

